import React from "react"
import KEYBlue from "../common/keylist-blue"

const OpencartServices: React.FC = () => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10 gap-5 md:gap-5 lg:gap-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
            <h2 className="fw-700 fs-xl">
              Serving Multiple Segments, Our OpenCart Services Includes:
              </h2>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="API Integration &amp; Module Development" />
              <KEYBlue text="Custom OpenCart Development " />
              <KEYBlue text="OpenCart Migration Solution " />
              <KEYBlue text="Third-party App &amp; Libraries Integration " />
              <KEYBlue text="Custom Theme Design &amp; Integration " />
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Payment Gateway Integration " />
            <KEYBlue text="OpenCart Website Development " />
            <KEYBlue text="OpenCart E-Commerce solution " />
            <KEYBlue text=" Support &amp; Maintenance" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OpencartServices
